import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { Minus, Plus } from 'lucide-react';
export function FAQSection() {
  const faqs = [{
    question: 'Wie erhalte ich das Material?',
    answer: 'Der Zugang ist sofort. Sobald deine Zahlung bestätigt ist, erhältst du eine E-Mail mit dem Link, um das gesamte Kit auf Handy, Tablet oder Computer herunterzuladen.'
  }, {
    question: 'Ist es geeignet, wenn ich Anfängerin bin?',
    answer: 'Absolut! Ideal, um dir in deinen ersten Stunden Sicherheit zu geben. Du hast die Struktur fertig, logische Sequenzen und einsatzbereite Themen.'
  }, {
    question: 'Für welche Yoga-Stile ist es geeignet?',
    answer: 'Die Stunden sind vor allem für Hatha und Vinyasa konzipiert, mit Anpassungsmöglichkeiten. Zusätzlich gibt es ein spezielles Modul für Therapeutisches Yoga.'
  }, {
    question: 'Sind die Boni in den 19 € enthalten?',
    answer: 'Ja, alle 5 Boni (Rituale, Musik, Korrekturen, Captions und Tracker) sind zu 100% frei in deinem heutigen Kauf enthalten.'
  }, {
    question: 'In welchem Format sind die Dateien?',
    answer: 'Das gesamte Material liegt als hochwertiges PDF vor, bereit zum Lesen auf jedem Gerät oder zum Ausdrucken.'
  }, {
    question: 'Muss ich monatlich zahlen?',
    answer: 'Nein, es ist eine Einmalzahlung. Einmal gekauft, gehört es dir für immer.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="bg-white px-4 py-20" data-id="element-39">
      <div className="mx-auto max-w-3xl" data-id="element-40">
        <h2 className="mb-12 text-center text-3xl font-black text-brand-text md:text-4xl" data-id="element-41">
          Häufige Fragen
        </h2>
        <div className="space-y-4" data-id="element-42">
          {faqs.map((faq, index) => {
          const isOpen = openIndex === index;
          return <div key={faq.question} className="overflow-hidden rounded-2xl border border-brand-creamDark bg-[#EDE5D8]" data-id="element-43">
                <button type="button" onClick={() => setOpenIndex(isOpen ? null : index)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-4 px-6 py-5 text-left focus:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-brand-green" data-id="element-44">
                  <span className="font-bold text-brand-text" data-id="element-45">
                    {faq.question}
                  </span>
                  {isOpen ? <Minus className="h-5 w-5 shrink-0 text-brand-green" aria-hidden="true" data-id="element-46" /> : <Plus className="h-5 w-5 shrink-0 text-brand-text" aria-hidden="true" data-id="element-47" />}
                </button>
                <AnimatePresence initial={false} data-id="element-48">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.25,
                ease: 'easeInOut'
              }} data-id="element-49">
                      <div className="px-6 pb-5 leading-relaxed text-brand-gray" data-id="element-50">
                        {faq.answer}
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>
      </div>
    </section>;
}